export enum BirthTypeEnum {
	abortion_lactation = 'abortion_lactation',
	normal = 'normal',
	caesarean = 'caesarean',
	dystocic_birth = 'dystocic_birth',
}
